import { useTranslation } from "@hooks/useTranslation";
import { cn } from "@lib/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { MdChevronRight } from "react-icons/md";

export default function FilterByButton({
  className = "",
  arrow = "down",
}: {
  className?: string;
  arrow?: "up" | "down";
}) {
  const { query } = useRouter();

  const { t } = useTranslation();

  const showFilters = query.show_filters === "true";

  return (
    <Link
      href={{
        query: { ...query, show_filters: arrow === "down" },
      }}
      className={cn(
        "flex items-center justify-center px-2 py-1 border border-gray-200 md:border-gray-800 rounded w-fit",
        className
      )}
      shallow
    >
      <p
        className={cn("text-white uppercase text-[0.70rem] pr-0.5", {
          "md:text-black": !showFilters,
        })}
      >
        {t("spotprofile.filter_by")}
      </p>
      <MdChevronRight
        className={`text-[1.20rem] rotate-90 text-primary-color ${
          arrow === "up" ? "-rotate-90" : "rotate-90"
        }`}
      />
    </Link>
  );
}
